import GuideRow from "../../../GuideRow";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import GuideVlessLinkData from "components/guides/GuideVlessLinkData";
import GuideVlessQrData from "components/guides/GuideVlessQrData";

const MacosGuide = ({ subscription, servers = [] }) => {
  const navigate = useNavigate();
  const { t, _ } = useTranslation();
  if (!subscription) {
    return;
  }

  return (
    <>
      <GuideRow
        number="1"
        text={t("Install the Happ app")}
        action={
          <div className="column">
            <a
              className="link mb-1 mt-05"
              href="https://apps.apple.com/us/app/happ-proxy-utility/id6504287215"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("Open App Store Global")}
            </a>
            <a
              className="link"
              href="https://apps.apple.com/ru/app/happ-proxy-utility/id6783623643"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("Open App Store RUS")}
            </a>
          </div>
        }
      />
      <GuideRow
        number="2"
        text={t("Open Happ and import the configuration file")}
        actionPaddingLeft="none"
        action={
          <>
            <GuideVlessLinkData
              subscription={subscription}
              label={t("Subscription link")}
            />
            <GuideVlessQrData
              subscription={subscription}
              label={t("Subscription QR code")}
            />
          </>
        }
      />
    </>
  );
};

export default MacosGuide;
